module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-15-cf062df03466f8e4108569af8b863f0e.svg";